import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import CollapsibleSidebar from "../Components/CollapsibleSidebar";
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import { useRoutingPriority } from "../hooks/useRoutingPriority"; // Adjust the path as needed
import { Toaster } from "react-hot-toast";
import { useNavigate, useLocation } from "react-router-dom";

const RoutingPriority: React.FC = () => {
  const {
    assignmentTypes,
    priorities,
    isEditMode,
    ranks,
    loading,
    error,
    selectedRows,
    toggleCleared,
    searchText,
    setSearchText,
    setIsEditMode,
    isSidebarCollapsed,
    setIsSidebarCollapsed,
    handleRankChange,
    toggleSidebar,
    handleRowSelected,
    handleClearSelected,
    handleSave,
    fetchAndInitializeData,
    tableData,
    filteredData,
    testData,
  } = useRoutingPriority();

  const [isLoading, setIsLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const getMenus = async () => {
      setIsLoading(true);
      try {
        const menuID = location.state?.menuID;
        const previousMenuID = localStorage.getItem("activeMenuID");
        if (menuID !== previousMenuID || menuID === null) {
          localStorage.setItem("activeMenuID", menuID);
        } else {
          localStorage.removeItem("activeMenuID");
        }
      } catch (error) {
        console.error("Error fetching menus:", error);
      } finally {
        setIsLoading(false);
      }
    };

    getMenus();
  }, [location]);

  const columns = [
    {
      name: "Assignment Type",
      selector: (row: any) => row.typeName,
      sortable: true,
      cell: (row: any) => (
        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <div
            style={{
              width: "24px",
              height: "24px",
              borderRadius: "50%",
              backgroundColor: "rgb(167 133 144)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: "white",
              fontSize: "10px",
              fontWeight: "bold",
            }}
          >
            {row.typeName.charAt(0).toUpperCase()}
          </div>
          <span style={{ fontWeight: "500", color: "#33475b" }}>
            {row.typeName}
          </span>
        </div>
      ),
      width: "400px",
    },
    {
      name: "Priority",
      selector: (row: any) => row.rank,
      cell: (row: any) =>
        isEditMode ? (
          <input
            type="number"
            value={ranks[row.typeId] || ""}
            onChange={(e) => handleRankChange(row.typeId, e.target.value)}
            onKeyDown={(e) => {
              if (
                [
                  "Backspace",
                  "Tab",
                  "ArrowLeft",
                  "ArrowRight",
                  "Delete",
                ].includes(e.key)
              ) {
                return;
              }
              if (!/^\d$/.test(e.key)) {
                e.preventDefault();
              }
            }}
            className="p-1 form-control-custom-tbl"
            disabled={!isEditMode}
            min="1"
            max={assignmentTypes.length}
          />
        ) : (
          row.rank
        ),
      sortable: true,
    },
  ];

  // if (loading) {
  //   return <div className="p-4 text-center">Loading priorities data...</div>;
  // }

  // if (error) {
  //   return <div className="p-4 text-red-500">Error: {error}</div>;
  // }

  return (
    <div className="wrapper">
      <div>
        <Toaster
          position="top-center"
          reverseOrder={false}
          containerStyle={{
            zIndex: 10000,
          }}
        />
      </div>
      {!isSidebarCollapsed && <CollapsibleSidebar />}
      <div className="main">
        <Navbar onToggleSidebar={toggleSidebar} />
        <div className="main-content-div">
          <div className="main-header-div"></div>
          <main className="content mainContent">
            <div className="container-fluid p-0">
              <div className="row">
                <div className="col-12 col-lg-12">
                  <div className="card">
                    <div className="card-header carHeaderWithBtn">
                      <div className="card-title mb-0">
                        Routing Priority Management
                        {selectedRows.length > 0 && (
                          <span className="badge bg-primary ms-2">
                            {selectedRows.length} selected
                          </span>
                        )}
                      </div>
                      <div>
                        <input
                          type="text"
                          placeholder="Search by Assignment Type"
                          className="p-2 w-full datatableSearchInput"
                          value={searchText}
                          onChange={(e) => setSearchText(e.target.value)}
                        />
                        <button
                          className="demo-btn btn btn-outline-primary btn-sm"
                          onClick={async () => {
                            console.log(
                              "Toggling edit mode to true and refreshing data"
                            );
                            await fetchAndInitializeData();
                            setIsEditMode(true);
                          }}
                          disabled={isEditMode}
                        >
                          + Edit Priorities
                        </button>
                      </div>
                    </div>
                    <div className="card-body p-0">
                      <DataTable
                        key={toggleCleared ? "cleared" : "uncleared"}
                        columns={columns}
                        data={testData}
                        pagination
                        paginationPerPage={10}
                        highlightOnHover
                        striped
                        responsive
                        noDataComponent="No priorities found"
                        selectableRows
                        selectableRowsComponentProps={{
                          className: "custom-checkbox",
                        }}
                        onSelectedRowsChange={handleRowSelected}
                        clearSelectedRows={toggleCleared}
                      />
                    </div>
                    {isEditMode && (
                      <div className="card-footer d-flex justify-content-between">
                        <div></div>
                        <div className="d-flex gap-2">
                          <button
                            className="btn btn-secondary"
                            onClick={() => {
                              setIsEditMode(false);
                              handleClearSelected();
                            }}
                          >
                            Cancel
                          </button>
                          <button
                            className="btn btn-primary"
                            onClick={handleSave}
                            disabled={loading || !!error}
                          >
                            {loading ? "Saving..." : "Save Priorities"}
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </main>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default RoutingPriority;
